import { AppRoutes, idRouter } from '../../app/routes/utils';

export const REVIEW_PARAM = '?flow=review';
export const FROM_DEALERS = '&source=dealers';
export const FROM_CUSTOMERS = '&source=customers';

export enum ReviewSource {
  Customers = 'customers',
  Dealers = 'dealers',
}

export function buildServiceAgreementReviewUrl(serviceAgreementId: string, source: ReviewSource) {
  return idRouter(AppRoutes.ServiceAgreement, serviceAgreementId)
    .concat(REVIEW_PARAM)
    .concat(source === ReviewSource.Dealers ? FROM_DEALERS : FROM_CUSTOMERS);
}

export const navigateToReviewPage = (serviceAgreementId: string, source: ReviewSource) => {
  const url = buildServiceAgreementReviewUrl(serviceAgreementId, source);
  window.open(url, '_blank');
};

export const navigateToCustomerSupportAuthURL = (
  serviceAgreementId: string,
  businessPartnerId: string
) => {
  // silently set the current URL to home (no navigation) so the auth redirect
  // will use the safe path as the 'redirect_url' / currentRelativeURL
  try {
    window.history.replaceState(null, '', '/');
  } catch {
    // ignore if replaceState unavailable
  }

  const url = `/api/auth?bind_type=service_agreement&bind_id=${serviceAgreementId}&tcbp=${businessPartnerId}`;
  window.location.assign(url);
};
